/**
 * The roster import modal's flow-step tours. Each step component runs its own tour, so it mounts
 * and unmounts with that step. They auto-run the first time only and are not in the Guided tours
 * list, since they only make sense mid-import.
 *
 * The upload and extracting screens have no web tour (`roster-import.extraction` is mobile only),
 * and neither does the success screen.
 */
export const ROSTER_IMPORT_FEATURE = "roster-import";

export const ROSTER_IMPORT_TOURS = {
  uploadType: "roster-import.upload-type",
  fieldMapping: "roster-import.field-mapping",
  teamSelection: "roster-import.team-selection",
  multiTeamReview: "roster-import.multi-team-review",
} as const;
